import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Checkbox from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';

const SignalFilters = ({ filters, onFiltersChange, onResetFilters }) => {
  const signalTypeOptions = [
    { value: 'all', label: 'All Signals' },
    { value: 'buy', label: 'Buy Signals' },
    { value: 'sell', label: 'Sell Signals' },
    { value: 'hold', label: 'Hold Signals' }
  ];

  const confidenceOptions = [
    { value: 'all', label: 'All Confidence Levels' },
    { value: 'high', label: 'High (80%+)' },
    { value: 'medium', label: 'Medium (60-79%)' },
    { value: 'low', label: 'Low (<60%)' }
  ];

  const timeframeOptions = [
    { value: 'all', label: 'All Timeframes' },
    { value: '1h', label: '1 Hour' },
    { value: '4h', label: '4 Hours' },
    { value: '1d', label: '1 Day' },
    { value: '1w', label: '1 Week' }
  ];

  const cryptoOptions = [
    { value: 'all', label: 'All Cryptocurrencies' },
    { value: 'BTC', label: 'Bitcoin (BTC)' },
    { value: 'ETH', label: 'Ethereum (ETH)' },
    { value: 'ADA', label: 'Cardano (ADA)' },
    { value: 'SOL', label: 'Solana (SOL)' },
    { value: 'DOT', label: 'Polkadot (DOT)' },
    { value: 'MATIC', label: 'Polygon (MATIC)' },
    { value: 'AVAX', label: 'Avalanche (AVAX)' }
  ];

  const handleFilterChange = (key, value) => {
    onFiltersChange({
      ...filters,
      [key]: value
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-card-foreground">Filter Signals</h3>
        <Button
          variant="ghost"
          size="sm"
          onClick={onResetFilters}
          iconName="RotateCcw"
          iconPosition="left"
        >
          Reset
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <Select
          label="Signal Type"
          options={signalTypeOptions}
          value={filters?.signalType}
          onChange={(value) => handleFilterChange('signalType', value)}
        />

        <Select
          label="Confidence Level"
          options={confidenceOptions}
          value={filters?.confidence}
          onChange={(value) => handleFilterChange('confidence', value)}
        />

        <Select
          label="Timeframe"
          options={timeframeOptions}
          value={filters?.timeframe}
          onChange={(value) => handleFilterChange('timeframe', value)}
        />

        <Select
          label="Cryptocurrency"
          options={cryptoOptions}
          value={filters?.cryptocurrency}
          onChange={(value) => handleFilterChange('cryptocurrency', value)}
          searchable
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <Input
          label="Minimum Confidence (%)"
          type="number"
          placeholder="Enter minimum confidence"
          value={filters?.minConfidence}
          onChange={(e) => handleFilterChange('minConfidence', e?.target?.value)}
          min="0"
          max="100"
        />

        <Input
          label="Search Pairs"
          type="search"
          placeholder="Search cryptocurrency pairs..."
          value={filters?.searchQuery}
          onChange={(e) => handleFilterChange('searchQuery', e?.target?.value)}
        />
      </div>
      <div className="flex flex-wrap gap-4">
        <Checkbox
          label="Show only active signals"
          checked={filters?.activeOnly}
          onChange={(e) => handleFilterChange('activeOnly', e?.target?.checked)}
        />

        <Checkbox
          label="High urgency only"
          checked={filters?.highUrgencyOnly}
          onChange={(e) => handleFilterChange('highUrgencyOnly', e?.target?.checked)}
        />

        <Checkbox
          label="Include expired signals"
          checked={filters?.includeExpired}
          onChange={(e) => handleFilterChange('includeExpired', e?.target?.checked)}
        />
      </div>
    </div>
  );
};

export default SignalFilters;